module.exports = __webpack_public_path__ + "static/media/BobabarWireframes.37231630.png";